/**
 * App Component
 * Main Application mit Routing
 */

import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from '@/context/ThemeContext'
import { LanguageProvider } from '@/context/LanguageContext'
import { Header } from '@/components/ui/Header'
import { Footer } from '@/components/ui/Footer'
import { ScrollToTop } from '@/components/ScrollToTop'
import { HomePage } from '@/pages/HomePage'
import { GalleryPage } from '@/pages/GalleryPage'
import { CategoryPage } from '@/pages/CategoryPage'
import { ArtworkPage } from '@/pages/ArtworkPage'
import { AboutPage } from '@/pages/AboutPage'
import { KuenstlerinPage } from '@/pages/KuenstlerinPage'
import { KuenstlerinSubPage } from '@/pages/KuenstlerinSubPage'
import { AusstellungenPage } from '@/pages/AusstellungenPage'
import { AusstellungProjektPage } from '@/pages/AusstellungProjektPage'
import { KunstFuerDichPage } from '@/pages/KunstFuerDichPage'
import { KontaktPage } from '@/pages/KontaktPage'
import { ImpressumPage } from '@/pages/ImpressumPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { LightingPanel } from '@/components/ui/LightingPanel'
import '@/styles/global.css'
import '@/styles/animations.css'

export function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/galerie" element={<GalleryPage />} />
          <Route path="/galerie/:slug" element={<CategoryPage />} />
          <Route path="/werk/:category/:slug" element={<ArtworkPage />} />
          <Route path="/kuenstlerin" element={<KuenstlerinPage />} />
          <Route path="/kuenstlerin/:slug" element={<KuenstlerinSubPage />} />
          <Route path="/ausstellungen" element={<AusstellungenPage />} />
          <Route path="/ausstellungen/:slug" element={<AusstellungProjektPage />} />
          <Route path="/kunst-fuer-dich" element={<KunstFuerDichPage />} />
          <Route path="/kontakt" element={<KontaktPage />} />
          <Route path="/ueber" element={<AboutPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
        <LightingPanel />
      </BrowserRouter>
      </LanguageProvider>
    </ThemeProvider>
  )
}
